export default "__VITE_ASSET__9vWoaISr__"